var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 52,
    r: 52,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.22 50.02c1.812 1.072 1.812 3.692 0 4.763L47.124 66.08c-1.845 1.091-4.176-.238-4.176-2.381V41.103c0-2.142 2.331-3.472 4.176-2.38L66.22 50.02z",
    fill: "#fff"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTA0IDEwNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iNTIiIGN5PSI1MiIgcj0iNTIiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8cGF0aCBkPSJNNjYuMjIwOSA1MC4wMjA1QzY4LjAzMTYgNTEuMDkxNyA2OC4wMzE2IDUzLjcxMTggNjYuMjIwOSA1NC43ODI5TDQ3LjEyMjYgNjYuMDgxMUM0NS4yNzgzIDY3LjE3MjIgNDIuOTQ3MiA2NS44NDI4IDQyLjk0NzIgNjMuNjk5OUw0Mi45NDcyIDQxLjEwMzVDNDIuOTQ3MiAzOC45NjA2IDQ1LjI3ODMgMzcuNjMxMiA0Ny4xMjI2IDM4LjcyMjNMNjYuMjIwOSA1MC4wMjA1WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";
export { SvgPlay as ReactComponent };